import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable } from 'mobx'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Loader from '../../shared/components/Loader'
import ErrorContainer from '../../shared/containers/Error'
import AdminFormPage from '../components/AdminFormPage'
import syncTransaction from '../../shared/syncTransaction'

@inject('program', 'auth') @observer
class AdminFormContainer extends Component {

  /* eslint-disable react/sort-comp */
  @observable isSaving = null

  @observable error = null
  /* eslint-enable react/sort-comp */

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.load(props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  @autobind
  handleClose() {
    // On close go back to startpage as defined in #65
    this.props.router.push('/')
  }

  @autobind
  handleSave(model) {
    if (!this.props.program.contains(model)) {
      this.props.program.add(model)
    }

    return this::syncTransaction(model.save({ action: 'settings' }))
  }

  load({ program, params: { id } }) {
    if (!id) {
      throw new Error('Missing program id!')
    }
    else {
      program.openById(id * 1)
    }
  }

  render() {
    const {
      auth,
      program,
      program: { current },
      params: { id }
    } = this.props

    if (!auth || !auth.user) {
      return (<div>Auth Service noch nicht verfügbar</div>)
    }

    if (!auth.acs.isAuthorized('SUPERADMIN')) {
      return (
        <div>
          Einstellungen können nur vom Superadmin vorgenommen werden!
          <button onClick={this.handleClose}>
            Zurück
          </button>
        </div>
      )
    }

    if (program.loading) {
      return <Loader>Daten werden geladen</Loader>
    }

    if (
      !current
      || (current.id && current.id !== id * 1)
    ) {
      return <ErrorContainer>Fehler beim Laden</ErrorContainer>
    }

    return (
      <div className="horizontal">

        <ErrorContainer
          className="error-layer"
          causingComponent={this}
        />

        <AdminFormPage
          current={current}
          onClose={this.handleClose}
          onSave={this.handleSave}
          isBusy={this.isSaving}
        />

      </div>
    )
  }
}

const AdminFormContainerWithRouter = withRouter(AdminFormContainer)

export { AdminFormContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/program/containers/AdminForm.js